import type { SearchState } from '../api/types'

/** Explicit guest quantities win; automatic adults follow the selected type. */
export function searchForRoom(search: SearchState, room: { default_pax?: number }): SearchState {
  return {
    ...search,
    adults: search.adultsManuallySet === false
      ? Math.max(1, room.default_pax || 1)
      : search.adults,
  }
}
